<div class="dasa-chooser">
  <div class="dasa-chooser__header">
    <h2 class="dasa-chooser__title">Choose a business</h2>
    <p class="dasa-chooser__subtitle">Select the business you want to manage today.</p>
  </div>

  <div class="dasa-chooser__grid">
    <button *ngFor="let data of businesses; let i = index"
            type="button"
            class="dasa-chooser__card"
            (click)="openSelectedBuisness(data.id)">
      <div class="dasa-chooser__card-logo">
        <img [src]="fileUrl + data.logo" [alt]="data.name" />
      </div>
      <div class="dasa-chooser__card-info">
        <div class="dasa-chooser__card-name">{{ data.name }}</div>
        <div class="dasa-chooser__card-cta">
          Open <i class="fa-solid fa-arrow-right"></i>
        </div>
      </div>
    </button>
  </div>
</div>
